import { Routes } from '@angular/router';
import { RepairNetwork } from './main/repair-network/repair-network';
import { SupplierNetwork } from './main/supplier-network/supplier-network';
import { GarageDetails } from './main/garage-details/garage-details';
import { RegistrationDecode } from './main/registration-decode/registration-decode';
import { Make } from './main/make/make';
import { Model } from './main/model/model';
import { Year } from './main/year/year';
import { Variant } from './main/variant/variant';
import { EstimateList } from './main/estimate-list/estimate-list';
import { EstimateDetails } from './main/estimate-details/estimate-details';
import { EstimateDetailsDownload } from './main/estimate-details-download/estimate-details-download';
import { Loading } from './main/loading/loading';
import { PeriodicServiceDetails } from './main/periodic-service-details/periodic-service-details';
import { TyreIssueDetails } from './main/tyre-issue-details/tyre-issue-details';
import { AcNotCollingDetails } from './main/ac-not-colling-details/ac-not-colling-details';
import { BrakeNoiseDetails } from './main/brake-noise-details/brake-noise-details';
import { CarNotStartingDetails } from './main/car-not-starting-details/car-not-starting-details';
import { DentingAndPaintingDetails } from './main/denting-and-painting-details/denting-and-painting-details';
import { EngineNoiseDetails } from './main/engine-noise-details/engine-noise-details';
import { SteeringIssueDetails } from './main/steering-issue-details/steering-issue-details';
import { InsuranceClaim } from './insurance-claim/insurance-claim';

export const routes: Routes = [
    { path: '', component: RepairNetwork },
    { path: 'repair-network', component: RepairNetwork },
    { path: 'supplier-network', component: SupplierNetwork },
    { path: 'garage-details/:key', component: GarageDetails },
    { path: 'registration-decode', component: RegistrationDecode },
    { path: 'make', component: Make },
    { path: 'model', component: Model },
    { path: 'year', component: Year },
    { path: 'variant', component: Variant },
    { path: 'estimate-list', component: EstimateList },
    { path: 'insurance-claim', component: InsuranceClaim },
    { path: 'estimate-details/:id/:name', component: EstimateDetails },
    { path: 'estimate-details-download', component: EstimateDetailsDownload },
    { path: 'loading', component: Loading },
    {
        path: 'periodic-service-details',
        component: PeriodicServiceDetails,
        data: { serviceKey: 'PERIODIC_SERVICE' }
    },
    {
        path: 'steering-issue-details',
        component: SteeringIssueDetails,
        data: { serviceKey: 'SUSPENSION_STEERING' }
    },
    {
        path: 'tyre-issue-details',
        component: TyreIssueDetails,
        data: { serviceKey: 'TYRE_ISSUES' }
    },
    {
        path: 'ac-not-colling-details',
        component: AcNotCollingDetails,
        data: { serviceKey: 'AC_ISSUES' }
    },
    {
        path: 'brake-noise-details.html',
        component: BrakeNoiseDetails,
        data: { serviceKey: 'BRAKE_ISSUES' }
    },
    {
        path: 'car-not-starting-details',
        component: CarNotStartingDetails,
        data: { serviceKey: 'CAR_NOT_STARTING' }
    },
    {
        path: 'denting-and-painting-details',
        component: DentingAndPaintingDetails,
        data: { serviceKey: 'DENTING_PAINTING' }
    },
    {
        path: 'engine-noise-details.html',
        component: EngineNoiseDetails,
        data: { serviceKey: 'ENGINE_ISSUES' }
    },
    {
    path: 'insurance-claim',
        loadComponent: () =>
        import('./insurance-claim/insurance-claim').then(m => m.InsuranceClaim)
    }

];
